import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CircularDetailsWrapper from "./routes/CircularDetailsWrapper";
export default store => ({
  path: "circulars",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-communications" */ "./components"
        ),
        import(
          /* webpackChunkName: "administrator-communications" */ "Circulars/modules/CircularsModule"
        ),
        import(
          /* webpackChunkName: "administrator-communications" */ "Announcements/modules/AnnouncementModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const moduleV1 = importedModule1;
        const moduleV2 = importedModule2;
        const reducer = moduleV1.default;
        const key = moduleV1.NAME;
        injectReducer(store, {
          key,
          reducer,
        });

        // Injecting V2 reducer

        const reducerV2 = moduleV2.default;
        const keyV2 = moduleV2.NAME;
        injectReducer(store, {
          key: keyV2,
          reducer: reducerV2,
        });
        return component;
      })
    // .catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CircularDetailsWrapper(store), // NOTE: keep this at bottom
  ],
});
